module.exports = __webpack_public_path__ + "static/img/dz9.1843fcc4.png";